module.exports = __webpack_public_path__ + "img/triangle.893bf858.svg";